/**
 * @project: certiapp-nuxt
 * @file:    \store\plantillas-checklist.js
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 29th October 2021
 * Last Modified: Wed Jun 21 2023
 **/

import { uuid } from 'vue-uuid'

export const state = () => ({
  list: [],
})

//commit mutations
export const mutations = {
  GET_LIST(state) {
    return state.list
  },
  SET_LIST(state, items) {
    state.list = items
  },
}
//dispatch actions
export const actions = {
  // Checklist
  async list({ rootState, commit }, subalcance_uuid) {
    rootState.loading = true
    let listResults = []
    let res = null
    if (subalcance_uuid) {
    res = await this.$axios.get('plantilla_checklists?subalcance.uuid='+subalcance_uuid+'&modulo=revisiones')
    } else {
      res = await this.$axios.get('plantilla_checklists')
    }

    rootState.loading = false
    if (res) {
      listResults = res.data['hydra:member']
      commit('SET_LIST', listResults)
      return listResults
    }
  },

  async listByModulo({ rootState, commit }, data) {
    rootState.loading = true
    let listResults = []
    let res = null
    if (data.subalcance_uuid && data.modulo) {
    res = await this.$axios.get('plantilla_checklists?subalcance.uuid='+data.subalcance_uuid+'&modulo='+data.modulo)
    } else {
      res = await this.$axios.get('plantilla_checklists')
    }

    rootState.loading = false
    if (res) {
      listResults = res.data['hydra:member']
      commit('SET_LIST', listResults)
      return listResults
    }
  },

  async get({ rootState }, uuid) {
    rootState.loading = true
    const res = await this.$axios.get(`plantilla_checklists/${uuid}`)
    rootState.loading = false
    if (res) return res.data
  },

  async create({ rootState }, plantilla) {
    // rootState.loading = true
    const body = {
      uuid: plantilla.uuid,
      titulo: plantilla.titulo,
      alcance: plantilla.alcance.uuid,
      is_revision: plantilla.isRevision,
    }
    await this.$axios.post('plantilla_checklists', body)
    // rootState.loading = false
  },

  async update({ rootState }, plantilla) {
    // rootState.loading = true

    // create an array of uuids from plantilla.preguntas with map
    const preguntas = plantilla.preguntas.map((pregunta) => {
      return pregunta.uuid
    })

    const body = {
      uuid: plantilla.uuid,
      titulo: plantilla.titulo,
      plantilla_checklist: plantilla.uuid,
      is_revision: plantilla.is_revision,
      preguntas: preguntas,
    }

    await this.$axios.patch(`plantilla_checklists${plantilla.uuid}`, body)
    // rootState.loading = false
  },

  async updateIsRevision({ rootState }, plantilla) {
    rootState.loading = true
    const body = {
      plantilla_checklist: plantilla.uuid,
      is_revision: plantilla.is_revision,
    }
    await this.$axios.patch(`plantilla_checklists/${plantilla.uuid}/update-is-revision`, body)
    rootState.loading = false
  },

  async updateActivo({ rootState }, plantilla) {
    rootState.loading = true
    const body = {
      plantilla_checklist: plantilla.uuid,
      activo: plantilla.activo,
    }
    await this.$axios.patch(`plantilla_checklists/${plantilla.uuid}/update-activo`, body)
    rootState.loading = false
  },

  async delete({ rootState }, plantilla) {
    rootState.loading = true
    await this.$axios.delete(`plantilla_checklists/${plantilla.uuid}`).then((res) => {
      this.commit('notification/show', {
        color: 'success',
        text: this.$i18n.t('bannerMessages.checklistDeleted'),
      })
    })
    rootState.loading = false
  },

  async clone({ commit }, plantilla) {
    const res = await this.$axios.get(`plantilla_checklists/${plantilla.uuid}/clonar`)
    if (res) return res.data
  },

  // Preguntas
  async createPregunta({ rootState }, pregunta) {
    // rootState.loading = true
    pregunta.uuid = uuid.v4()
    await this.$axios.post(
      `plantilla_checklists/${pregunta.plantilla_checklist}/preguntas`,
      pregunta
    )
    // rootState.loading = false
  },

  async updatePregunta({ rootState }, params) {
    let loadingDisabled = false
    let pregunta = params
    if (params && params.loadingDisabled) {
      loadingDisabled = true
      pregunta = params.pregunta
    }
    if (!loadingDisabled) rootState.loading = true
    const body = {
      titulo: pregunta.titulo,
      informe: pregunta.informe,
      solo_titulo: pregunta.solo_titulo,
      plantilla_checklist: pregunta.plantilla_checklist,
      plantilla_checklist_pregunta: pregunta.uuid,
      nivel: pregunta.nivel,
      codigo: pregunta.codigo,
      relacion: pregunta.relacion,
      hint: pregunta.hint,
      observaciones: pregunta.observaciones,
      respuesta: pregunta.respuesta,
      bloques: pregunta.bloques,
      requisito_afectado: pregunta.requisito_afectado,
    }

    await this.$axios.patch(
      `plantilla_checklists/${pregunta.plantilla_checklist}/preguntas/${pregunta.uuid}`,
      body
    )
    if (!loadingDisabled) rootState.loading = false
  },

  async deletePregunta({ rootState }, pregunta) {
    rootState.loading = true
    await this.$axios
      .delete(`plantilla_checklists/${pregunta.plantilla_checklist}/preguntas/${pregunta.uuid}`)
      .then((res) => {
        this.commit('notification/show', {
          color: 'success',
          text: this.$i18n.t('bannerMessages.questionDeleted'),
        })
      })
    rootState.loading = false
  },

  async fusionar({ rootState }, params) {
    rootState.loading = true
    const body = {
      uuid: uuid.v4(),
      titulo: params.titulo,
      alcance: params.alcance,
      checklists: params.checklists,
    }
    await this.$axios.patch(`plantilla_checklists/fusionar`, body)
    rootState.loading = false
  },


  async newPlantilla({ rootState }, plantilla) {
    rootState.loading = true
  
    await this.$axios.post('plantilla_checklists', plantilla)
    rootState.loading = false
  },

  async updateNewPlantilla({ rootState }, plantilla) {
      try {
        await this.$axios.patch(
          `plantilla_checklists/${plantilla.uuid}`,
          plantilla,
          {
            headers: {
              'Content-Type': 'application/merge-patch+json'
            }
          }
        )
      } catch (error) {
          console.error(`There was a problem with the axios operation: ${error.message}`);
      }
  },

  async deleteNewPlantilla({ rootState }, plantilla) {
    rootState.loading = true
    await this.$axios.delete(`plantilla_checklists/${plantilla.uuid}`).then((res) => {
      this.commit('notification/show', {
        color: 'success',
        text: this.$i18n.t('bannerMessages.checklistDeleted'),
      })
    })
    rootState.loading = false
  },

  async deletePlantillaPregunta({ rootState }, pregunta) {
    await this.$axios.delete(`plantilla_pregunta_checklists/${pregunta.uuid}`)
  },

  async getPreguntasPlantillas({ rootState }, uuid) {

    rootState.loading = true
    const res = await this.$axios.get('plantilla_pregunta_checklists?plantilla_pregunta_checklists?page=1&itemsPerPage=100&plantillaChecklist.uuid='+uuid)
    let listResults = []
    if (uuid) {
      listResults = res.data['hydra:member']

    } else {
      listResults = res.data['hydra:member']
    }
    rootState.loading = false
  
    return listResults
    
  },
  async getPreguntasPlantillasFull({ rootState }, uuid) {
    rootState.loading = true

    let page = 1
    let results = []
    let hasNext = true

    while (hasNext) {
      const res = await this.$axios.get(
        `plantilla_pregunta_checklists?page=${page}&itemsPerPage=100&plantillaChecklist.uuid=${uuid}`
      )

      results = results.concat(res.data['hydra:member'])

      hasNext = !!res.data['hydra:view']?.['hydra:next']
      page++
    }

    rootState.loading = false
    return results
  },
  async createPreguntaPlantilla({ rootState }, pregunta) {
    rootState.loading = true
    await this.$axios.post('plantilla_pregunta_checklists', pregunta)
    rootState.loading = false
  },


  async updateNewPlantillaPreguntaChecklist({ rootState }, pregunta) {
    try {
      await this.$axios.patch(
        `plantilla_pregunta_checklists/${pregunta.uuid}`,
        pregunta,
        {
          headers: {
            'Content-Type': 'application/merge-patch+json'
          }
        }
      )
    } catch (error) {
          console.error(`There was a problem with the axios operation: ${error.message}`);
      }
  },


  async getBloques({ rootState }) {

    rootState.loading = true
    const res = await this.$axios.get('plantilla_bloques?page=1&itemsPerPage=100&modulo=checklist')
    let listResults = []
    if (uuid) {
      listResults = res.data['hydra:member']

    } else {
      listResults = res.data['hydra:member']
    }
    rootState.loading = false
  
    return listResults
    
  },

  async getPlantillaChecklistForSubalcae({ rootState }, uuid) {
    rootState.loading = true
    // const res = await this.$axios.get('plantilla_checklists?subalcance.uuid='+uuid)
    const res = await this.$axios.get('plantilla_checklists')
    let listResults = []
    if (uuid) {
      listResults = res.data['hydra:member']
    } else {
      listResults = res.data['hydra:member']
    }
    rootState.loading = false
    return listResults
  },
  
  async getAllPreguntasPlantillas({ rootState }) {

    rootState.loading = true
    const res = await this.$axios.get('plantilla_pregunta_checklists?plantilla_pregunta_checklists?page=1&itemsPerPage=100')
    let listResults = []
    if (uuid) {
      listResults = res.data['hydra:member']

    } else {
      listResults = res.data['hydra:member']
    }
    rootState.loading = false
  
    return listResults
    
  },

}
